<template>
  <section class="text-center">
    <h1 class="mt-8 text-4xl md:text-5xl lg:text-6xl tracking-tight font-black">
      Build Production-Ready AWS serverless systems.
    </h1>

    <p class="mt-4 max-w-5xl mx-auto text-xl md:text-2xl text-gray-200 leading-relaxed">
      Learn the patterns, trade-offs, and operational practices behind real-world
      AWS serverless systems - so you can design, test, deploy, and support them
      with confidence.
    </p>

    <div class="mx-auto flex flex-col place-items-center sm:text-lg md:text-2xl">
      <p class="mt-8 text-gray-400 text-sm sm:text-lg">Trusted by students from</p>

      <ul class="grid grid-cols-3 md:hidden w-full">
        <Logo :isLarge=false company="AWS" logo="website/logo-bw-aws.png" />
        <Logo :isLarge=false company="LEGO" logo="website/logo-bw-lego.png" />
        <Logo :isLarge=false company="Adobe" logo="website/logo-bw-adobe.png" />
        <!-- <Logo :isLarge=false company="Booking.com" logo="website/logo-bw-booking.png" /> -->
        <!-- <Logo :isLarge=true company="HBO" logo="website/logo-bw-hbo.png" /> -->
        <!-- <Logo :isLarge=true company="CapitalOne" logo="website/logo-bw-capitalone.png" /> -->
        <!-- <Logo :isLarge=true company="NordCloud" logo="website/logo-bw-nordcloud.png" /> -->
        <!-- <Logo :isLarge=false company="ThoughtWorks" logo="website/logo-bw-thoughtworks.png" /> -->
        <!-- <Logo :isLarge=true company="Siemens" logo="website/logo-bw-siemens.png" /> -->
      </ul>

      <ul class="hidden md:grid md:grid-cols-5 w-full">
        <Logo :isLarge=true company="AWS" logo="website/logo-bw-aws.png" />
        <!-- <Logo :isLarge=true company="LEGO" logo="website/logo-bw-lego.png" /> -->
        <Logo :isLarge=true company="Booking.com" logo="website/logo-bw-booking.png" />
        <Logo :isLarge=true company="Adobe" logo="website/logo-bw-adobe.png" />
        <Logo :isLarge=true company="ThoughtWorks" logo="website/logo-bw-thoughtworks.png" />
        <!-- <Logo :isLarge=true company="HBO" logo="website/logo-bw-hbo.png" /> -->
        <Logo :isLarge=true company="CapitalOne" logo="website/logo-bw-capitalone.png" />
        <!-- <Logo :isLarge=true company="NordCloud" logo="website/logo-bw-nordcloud.png" /> -->
        <!-- <Logo :isLarge=true company="Siemens" logo="website/logo-bw-siemens.png" /> -->
      </ul>
    </div>
  </section>
</template>

<script>
import Logo from './Logo.vue'

export default {
  components: {
    Logo
  },
  data () {
    return {
      vips: [{
        name: 'Sam Williams',
        img: 'logo-sam-williams.png',
        url: 'https://www.linkedin.com/in/sam-complete-coding',
        hideOnMobile: false
      }, {
        name: 'Sheen Brisals',
        img: 'logo-sheen-brisals.png',
        url: 'https://aws.amazon.com/developer/community/heroes/sheen-brisals',
        hideOnMobile: false
      }, {
        name: 'Matt Lewis',
        img: 'logo-matt-lewis.png',
        url: 'https://aws.amazon.com/developer/community/heroes/matt-lewis',
        hideOnMobile: false
      }, {
        name: 'Pawel Zubkiewicz',
        img: 'logo-pawel-zubkiewicz.png',
        url: 'https://aws.amazon.com/developer/community/heroes/pawel-zubkiewicz',
        hideOnMobile: false
      }, {
        name: 'Jannik Wempe',
        img: 'logo-jannik-wempe.png',
        url: 'https://twitter.com/JannikWempe',
        hideOnMobile: false
      }, {
        name: 'Vlad Ionescu',
        img: 'logo-vlad-ionescu.png',
        url: 'https://aws.amazon.com/developer/community/heroes/vlad-ionescu',
        hideOnMobile: true
      }, {
        name: 'Manoj Fernando',
        img: 'logo-manoj-fernando.png',
        url: 'https://aws.amazon.com/developer/community/heroes/manoj-fernando',
        hideOnMobile: false
      }, {
        name: 'Ibrahim Cesar',
        img: 'logo-ibrahim-cesar.png',
        url: 'https://www.linkedin.com/in/ibrahimcesar/',
        hideOnMobile: false
      }, {
        name: 'Albert Suwandhi',
        img: 'logo-albert-suwandhi.png',
        url: 'https://aws.amazon.com/developer/community/heroes/albert-suwandhi',
        hideOnMobile: true
      }, {
        name: 'Farzana Rahman',
        img: 'logo-farzana-rahman.png',
        url: 'https://www.linkedin.com/in/farzana-rahman-juthi-85aa9a25/',
        hideOnMobile: true
      }, {
        name: 'Tomasz Lakomy',
        img: 'logo-tomasz-lakomy.png',
        url: 'https://aws.amazon.com/developer/community/heroes/tomasz-lakomy',
        hideOnMobile: false
      }]
    }
  }
}
</script>
